import { List } from "antd";

export function getGeneralQueueMetaData() {
  return {
    id: 1,
    width: '50%',
    userKey: 'supervisor',
    dataColumns: [
      {
        title: 'General Queues',
        displayType: 'SUMMARY',
        columns: [
          {
            id: 1,
            title: 'Workable',
            displayType: 'WORKABLE',
            description: 'Workable',
            columnKey: 'workableCount',
          },
          {
            id: 2,
            title: 'New',
            displayType: 'STRING',
            description: 'New',
            columnKey: 'newCount',
          },
          {
            id: 3,
            title: 'Critical',
            displayType: 'CRITICAL',
            description: 'Critical',
            columnKey: 'criticalCount',
          },
        ],
      },
      {
        displayType: 'QUEUE_VIEW',
        id: 1,
        title: 'MY QUEUES',
        queueKey: 'myQueue',
        apiKey: 'my_queue_api',
        dropDownIsVisible: false,
      },
      {
        id: 2,
        displayType: 'QUEUE_VIEW',
        title: 'DEFAULT QUEUES',
        queueKey: 'defaultQueue',
        apiKey: 'queueDefaultList',
        dropDownIsVisible: true,
        dropDownselection: {
          id: 1,
          defSelectKey: 'regionDataList',
        },
      },
      {
        id: 3,
        displayType: 'QUEUE_VIEW',
        title: 'EXCEPTIONS QUEUES',
        queueKey: 'exceptionQueue',
        apiKey: 'queueExceptionList',
        dropDownIsVisible: false,
      }],
  };
}

export function getAssignedCasesMetaData(permission) {
  if (permission !== undefined && permission !== null && permission.case.canAssignCase) {
    return {
      id: 2,
      width: '50%',
      userKey: 'analyst',
      dataColumns: [{
        title: 'Assigned Cases',
        displayType: 'SUMMARY',
        showGroupSearch: true,
        columns: [
          {
            id: 1,
            title: 'Available To Work',
            displayType: 'STRING',
            description: 'Available To Work',
            columnKey: 'availableToWorkCount',
          },
          {
            id: 2,
            title: 'Completed',
            displayType: 'STRING',
            description: 'Completed',
            columnKey: 'completedCount',
          },
          {
            id: 3,
            title: 'Critical',
            displayType: 'CRITICAL',
            description: 'Critical',
            columnKey: 'assignedCasesCriticalCount',
          },
        ],
      }],
      config: [
        {
          title: 'Groups',
          description: '',
          displayType: 'DROPDOWN',
          width: '25%',
          defaultIsVisible: true,
        },
        {
          title: 'Search',
          description: '',
          displayType: 'SEARCH',
          width: '25%',
          defaultIsVisible: true,
        },
        {
          title: '',
          description: '',
          displayType: 'EXPAND',
          width: '50%',
          defaultIsVisible: true,
        },
      ],
    };
  } else {
    return {}
  }
}

export function getacquirerAccessList() {
  let userMXPermissions = JSON.parse(sessionStorage.getItem('state')).auth.user.parsedPermissions.queue.viewMxQueues;
  let userGPPermissions = JSON.parse(sessionStorage.getItem('state')).auth.user.parsedPermissions.queue.viewGPNQueues;
  let userHPYPermissions = JSON.parse(sessionStorage.getItem('state')).auth.user.parsedPermissions.queue.viewHPYQueues;
  
  var acquirerAccess=new Array();
  if (userMXPermissions) {
    acquirerAccess.push('MXP');
    acquirerAccess.push('MXI');

  }
   if (userGPPermissions) {
    acquirerAccess.push('GPN');
  }
  if(userHPYPermissions){
    acquirerAccess.push('HPY');
  }
  return acquirerAccess;
};

